import { AntDesign, Ionicons } from "@expo/vector-icons";
import { BlurView } from "expo-blur";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Modal, View, Text, Pressable } from "react-native";
import { useDispatch } from "react-redux";

import TransactionImage from "@/assets/transferimage.svg";
import Title from "@/components/Title";
import { setForm } from "@/context/actions/actions";

interface TransactionModalProps {
  visible: boolean;
  transaction: string;
  onClick?: (state: boolean) => void;
  onClose: () => void;
}

export default function TransactionModal(props: TransactionModalProps) {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  useEffect(() => {
    if (props.visible) {
      setTimeout(() => {
        dispatch(setForm({ transactionModalVisible: true }));
        props.onClose();
      }, 8000);
    }
  }, [props.visible]);

  return (
    <Modal visible={props.visible} transparent animationType="fade">
      <BlurView intensity={20} className="flex-1 justify-center items-center">
        <View className="p-6 bg-white1 border border-gray rounded-lg w-full h-full items-center relative shadow lg:w-104 lg:h-136">
          <Pressable className="absolute right-3 top-3" onPress={props.onClose}>
            <AntDesign name="close" size={24} color="black" />
          </Pressable>
          <View className="m-2">
            <Title text={t("common:modal.transaction.title")} />
          </View>
          {props.transaction === "SCHEDULED" && (
            <View className="flex-grow flex-col items-center justify-center">
              <TransactionImage width={160} height={160} />
              <View className="m-4">
                <AntDesign name="checkcircle" size={52} color="green" />
              </View>
              <Text className="text-darkergray text-center text-2xl m-2">
                {t("home/amount:card.transactionsuccess")}
              </Text>
              <Text className="text-xl text-center m-1">
                {t("home/amount:card.transactionscheduledsubtitle")}
              </Text>
            </View>
          )}
          {props.transaction === "SUCCESS" && (
            <View className="flex-grow flex-col items-center justify-center">
              <TransactionImage width={160} height={160} />
              <View className="m-4">
                <AntDesign name="checkcircle" size={52} color="green" />
              </View>
              <Text className="text-center text-2xl m-2">
                {t("home/amount:card.transactionsuccess")}
              </Text>
              <Text className="text-darkergray text-xl text-center m-1">
                {t("home/amount:card.transactionsuccesssubtitle")}
              </Text>
            </View>
          )}
          {props.transaction === "FAILED" && (
            <View className="flex-grow flex-col items-center justify-center">
              <TransactionImage width={160} height={160} />
              <View className="m-4">
                <AntDesign name="closecircle" size={52} color="red" />
              </View>
              <Text className="text-center text-2xl m-2">
                {t("home/amount:card.transactionfailed")}
              </Text>
              <Text className="text-darkergray text-xl text-center m-1">
                {t("home/amount:card.transactionfailedsubtitle")}
              </Text>
            </View>
          )}
          {props.transaction === "TIMEOUT" && (
            <View className="flex-grow flex-col items-center justify-center">
              <TransactionImage width={160} height={160} />
              <View className="m-4">
                <Ionicons name="time-outline" size={48} color="#FFBF00" />
              </View>
              <Text className="text-center text-2xl m-2">
                {t("home/amount:card.transactiontimeout")}
              </Text>
              <Text className="text-darkergray text-xl text-center m-1">
                {t("home/amount:card.transactiontimeoutsubtitle")}
              </Text>
            </View>
          )}
        </View>
      </BlurView>
    </Modal>
  );
}
